import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './css/masters/serious-game.css';

var gameRoot = document.getElementById('idix-serious-game-root');
var changeScreenCallback = null;
var loginInfoCallback = null;
var saveResultCallback = null;
var svgPath = "/img";

if(gameRoot.hasAttribute('data-change-screen-callback')){
    var changeScreenCallbackName = gameRoot.getAttribute('data-change-screen-callback');
    var fn = window[changeScreenCallbackName];
    if(typeof fn === 'function') {
        changeScreenCallback = fn;
    }
}
if(gameRoot.hasAttribute('data-login-info-callback')){
    var loginInfoCallbackName = gameRoot.getAttribute('data-login-info-callback');
    var fnlog = window[loginInfoCallbackName];
    if(typeof fnlog === 'function') {
        loginInfoCallback = fnlog;
    }
}
if(gameRoot.hasAttribute('data-save-result-callback')){
    var saveResultCallbackName = gameRoot.getAttribute('data-save-result-callback');
    var fnsav = window[saveResultCallbackName];
    if(typeof fnsav === 'function'){
        saveResultCallback = fnsav;
    }
}
if(gameRoot.hasAttribute('data-svg-path')){
    svgPath = gameRoot.getAttribute('data-svg-path');
}

(function(d,c,xhr,e){ 
    xhr = new XMLHttpRequest(); 
    xhr.open('GET', process.env.PUBLIC_URL + svgPath + '/sprite.svg', !0);
    xhr.onload = function () { 
        e = d.createElement('div'); 
        e.innerHTML = xhr.responseText; 
        d.body.insertBefore(e[c][0], d.body[c][0]); 
    }; xhr.send(); 
})(document, 'childNodes');

ReactDOM.render(
  <App
      changeScreenCallback={changeScreenCallback}
      loginInfoCallback={loginInfoCallback}
      saveResultCallback={saveResultCallback}
  />,
  gameRoot
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/